export default __webpack_public_path__ + "static/1-ee04a058becd1635e97804b9acc0553f.svg";